import { atom } from "recoil";

export const updateTenantDrawerState = atom({
    key: "updateTenantDrawerState", // unique ID (with respect to other atoms/selectors)
    default: null, // default value (aka initial value) 
})